import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api_call from "../../../globals/common_utilities/axios_old";
import CONSTANTURL from "../../../globals/common_utilities/constanturls";
import { API } from "../../../globals/constants";

const initialState = {
  loading: false,
  dashboardResponse: [],
  dashboardGraphResponse: [],
  error: "",
};

export const DashboardData = createAsyncThunk(
  "dashboard/api",
  ({ token, params }) => {
    return api_call(
      "get",
      `${CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].DASHBOARD + API.END_POINTS.ADMIN_DASHBOARD}`,
      params,
      {},
      {}
    );
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(DashboardData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(DashboardData.fulfilled, (state, action) => {
      state.loading = false;
      state.dashboardResponse = action.payload;
      state.error = "";
    });
    builder.addCase(DashboardData.rejected, (state, action) => {
      state.loading = false;
      state.dashboardResponse = [];
      state.error = action.error.message;
    });
  },
});

export const DashboardGraph = createAsyncThunk(
  "dashboardgraph/api",
  ({ token, graphPramas }) => {
    return api_call(
      "get",
      `${CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].DASHBOARD + API.END_POINTS.DASHBOARD_GRAPH}`,
      graphPramas,
      {},
      {}
    );
  }
);
const dashboardGraphSlice = createSlice({
  name: "dashboard",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(DashboardGraph.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(DashboardGraph.fulfilled, (state, action) => {
      state.loading = false;
      state.dashboardGraphResponse = action.payload;
      state.error = "";
    });
    builder.addCase(DashboardGraph.rejected, (state, action) => {
      state.loading = false;
      state.dashboardGraphResponse = [];
      state.error = action.error.message;
    });
  },
});
export const Dashboard = {
  Dashboard: dashboardSlice.reducer,
  DashboardGraph: dashboardGraphSlice.reducer,
};
